import { css } from "@emotion/react";
import { visuallyHiddenStyles } from "@newsela/angelou";

export const legendCss = css(visuallyHiddenStyles);

export const fieldsetCss = {
  border: "none",
  margin: 0,
  padding: 0,
};
